// extracted by mini-css-extract-plugin
export default {"wrapper":"hq-z","response":"iq-z","error":"jq-z","disabled":"kq-z","buttons":"lq-z","feedbackQuestionSection":"mq-z","yesNoWrapper":"nq-z"};